// extracted by mini-css-extract-plugin
module.exports = {"box":"View_box_mHK5x","emptyBox":"View_emptyBox_3Uizk","imgitem_img":"View_imgitem_img_17Z3N"};